import { render, staticRenderFns } from "./clinical-events-modal.vue?vue&type=template&id=e618f236"
import script from "./clinical-events-modal.vue?vue&type=script&lang=ts"
export * from "./clinical-events-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports